define('drops/calendar/calendar',[
    'jquery',
    'luxon',
    'lq/drop',
    'lq/style'
], function ($, luxon, Drop, Style) {
    'use strict';

    const { DateTime } = luxon;

    function Calendar(options) {
        Drop.call(this, $('<div/>'), options);

        this.$element.addClass('calendar');
    };

    Drop.extend(Calendar, Drop);

    Calendar.typeName = 'Calendar';

    Calendar.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.renderStyles();
        this.applyPosition();
    };

    Calendar.prototype.renderStyles = function () {
        if (this.data.styles) {
            this.$element.removeClass('default-calendar-style');
            Style.renderStyles(this, 'calendarstyle-');
        } else {
            var defaultStyle = Style.getDefaultStyleIdByDropType(this, true);

            if (defaultStyle) {
                this.$element.removeClass('default-calendar-style');
                Style.renderStyles(this, 'calendarstyle-', null, defaultStyle);
            } else {
                // .default-calendar-style is defined in the css file, and should be used as a reference for the generation
                // of the user defined styles
                this.$element.addClass('default-calendar-style');
            }
        }            
    };

    Calendar.prototype.render = function ($element) {
        return this.createAndRenderDrops($element);
    };

    Calendar.prototype.postRender = function () {
        this.openFirstView();
    };

    // This will open the view, but won't load any data.
    // The calendar view will wait until the user maps a value on to the calendar or executes the query.
    Calendar.prototype.openFirstView = function () {
        if (!this.pool.length)
            return;

        this.currentView = this.pool[0];
        this.currentView.$element.appendTo(this.$element);
        this.currentView.init();
        this.currentView.open(DateTime.now());
    };

    Calendar.prototype.getEnabledViews = function () {
        return _.map(this.pool, function(calendarView) {
            return {
                type: calendarView.type,
                id: calendarView.data.id
            }
        });
    };

    Calendar.prototype.openViewById = function (viewId) {
        var view = _.find(this.pool, function(calendarView) {
            return calendarView.data.id === viewId;
        });
        this.openView(view);
    };

    Calendar.prototype.openView = function (view) {
        var openDate = this.currentView ? this.currentView.getOpenDate() : DateTime.now();
        var selectedDate = this.currentView ? this.currentView.getSelectedDate() : null;

        if (this.currentView)
            this.currentView.$element.detach();

        this.currentView = view;
        this.currentView.$element.appendTo(this.$element);
        this.currentView.open(openDate);

        if (selectedDate)
            this.currentView.setSelectedDate(selectedDate);
        else
            this.currentView.clearSelectedDate();

        this.currentView.loadCalendarData();
    };

    Calendar.prototype.clearValue = function () {
        if (!this.currentView)
            return;
        this.currentView.clearSelectedDate();
    };

    Calendar.prototype.setValue = function (update) {
        if (!this.currentView)
            return;

        var date = $.type(update.value) === "date"
            ? DateTime.fromJSDate(update.value)
            : DateTime.fromISO(update.value);
        this.currentView.open(date);
        this.currentView.setSelectedDate(date);
        this.currentView.loadCalendarData();
    };

    Calendar.prototype.changeView = function (viewType) {
        for (var i = 0; i < this.pool.length; i++) {
            if (viewType === this.pool[i].type) {
                this.openView(this.pool[i]);
                break;
            }
        }
    };

    Calendar.prototype.licquidMethod_previous = function () {
        this.currentView.previous();
    };

    Calendar.prototype.licquidMethod_next = function () {
        this.currentView.next();
    };

    Calendar.prototype.licquidMethod_today = function () {
        this.currentView.open(DateTime.now());
        this.currentView.setSelectedDate(DateTime.now());
        this.currentView.loadCalendarData();
    };

    Calendar.prototype.licquidMethod_changeToDayView = function () {
        this.changeView('CalendarDayView');
    };

    Calendar.prototype.licquidMethod_changeToWeekView = function () {
        this.changeView('CalendarWeekView');
    };

    Calendar.prototype.licquidMethod_changeToMonthView = function () {
        this.changeView('CalendarMonthView');
    };

    Calendar.prototype.licquidMethod_changeToYearView = function () {
        this.changeView('CalendarYearView');
    };

    return Calendar;
});
